import type { Weighted } from '../types.js';

/** Standalone German nick words people build handles from. Non-sexual. */
export const DE_HANDLE_WORDS: string[] = [
  'schatzi', 'mausi', 'maus', 'bärchen', 'prinzessin', 'hase', 'häschen', 'keks', 'krümel', 'sonnenschein',
  'digga', 'bro', 'brudi', 'chef', 'king', 'queen', 'babo', 'boss', 'engel', 'zuckerschnecke',
  'knuddel', 'flocke', 'pupsi', 'spatz', 'spätzle', 'mäuschen', 'teddy', 'pumuckl', 'wuschel', 'zwerg',
  'kleene', 'dicker', 'kollege', 'habibi', 'canim', 'kanka', 'lauch', 'ehrenmann', 'ehrenfrau', 'diggi',
  'sternchen', 'blümchen', 'honigbiene', 'muffin', 'cupcake', 'brezel', 'krapfen', 'nugget', 'schnecke', 'igel',
  'pinguin', 'panda', 'koala', 'fuchsi', 'tiger', 'löwe', 'dino', 'kuschelbär', 'träumer', 'nachteule',
];

export const DE_HANDLE_ADJECTIVES: string[] = [
  'kleine', 'kleiner', 'süße', 'süßer', 'wilde', 'wilder', 'dunkle', 'dunkler', 'verrückte', 'verrückter',
  'müde', 'müder', 'stille', 'stiller', 'blaue', 'blauer', 'rote', 'roter', 'goldene', 'goldener',
  'lustige', 'lustiger', 'freche', 'frecher', 'coole', 'cooler', 'schöne', 'schöner', 'echte', 'echter',
  'kalte', 'kalter', 'leise','nordische', 'bayerische', 'kölsche', 'chaotische', 'chaotischer', 'verpeilte', 'verpeilter',
  'schlaue', 'schlauer', 'ruhige', 'ruhiger', 'mutige', 'mutiger', 'lieber', 'liebe', 'treue', 'treuer',
];

export const DE_HANDLE_NOUNS: string[] = [
  'maus', 'stern', 'fuchs', 'wolf', 'katze', 'kater', 'mond', 'engel', 'bär', 'löwe',
  'tiger', 'adler', 'falke', 'rabe', 'hase', 'igel', 'eule', 'biene', 'blume', 'rose',
  'sonne', 'wolke', 'welle', 'sturm', 'blitz', 'flamme', 'schatten', 'nebel', 'regen', 'schnee',
  'herz', 'traum', 'seele', 'krieger', 'ritter', 'pirat', 'nomade', 'träumer', 'vogel', 'drache',
  'kirsche', 'erdbeere', 'zitrone', 'keks', 'brezel', 'panda', 'pinguin', 'koala', 'delfin', 'hai',
];

/** Licence-plate city codes, weighted roughly by population. */
export const DE_PLACE_CODES: Weighted[] = [
  { name: 'B', weight: 37 }, { name: 'HH', weight: 19 }, { name: 'M', weight: 15 }, { name: 'K', weight: 11 },
  { name: 'F', weight: 8 }, { name: 'S', weight: 6 }, { name: 'D', weight: 6 }, { name: 'DO', weight: 6 },
  { name: 'E', weight: 6 }, { name: 'L', weight: 6 }, { name: 'HB', weight: 6 }, { name: 'DD', weight: 6 },
  { name: 'H', weight: 5 }, { name: 'N', weight: 5 }, { name: 'DU', weight: 5 }, { name: 'BO', weight: 4 },
  { name: 'W', weight: 4 }, { name: 'BI', weight: 3 }, { name: 'BN', weight: 3 }, { name: 'MS', weight: 3 },
  { name: 'MA', weight: 3 }, { name: 'KA', weight: 3 }, { name: 'WI', weight: 3 }, { name: 'GE', weight: 3 },
  { name: 'MG', weight: 3 }, { name: 'A', weight: 3 }, { name: 'AC', weight: 2 }, { name: 'KI', weight: 2 },
  { name: 'HD', weight: 2 }, { name: 'OF', weight: 2 }, { name: 'MZ', weight: 2 }, { name: 'KS', weight: 2 },
];
